module.exports = __webpack_public_path__ + "img/DS_40_5x7.081e83e6.jpg";